import { render, staticRenderFns } from "./CreateCaptainCar.vue?vue&type=template&id=2365d0ee"
import script from "./CreateCaptainCar.vue?vue&type=script&lang=js"
export * from "./CreateCaptainCar.vue?vue&type=script&lang=js"
import style0 from "./CreateCaptainCar.vue?vue&type=style&index=0&id=2365d0ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports